import { addressDrawerApplyButtonStyles as styles } from "@insite/content-library/Widgets/Header/AddressDrawerApplyButton";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.button = {
    ...styles.button,
    css: css`
        ${styles.button?.css}
        span {
            color: ${getColor(colorStrings.commonGlobalWhite)} !important;
        }

        &:disabled {
            span {
                color: ${getColor(colorStrings.textDisabled)} !important;
            }
        }
    `,
};
